/** Same gate shape as canExportWithLayers: transitions are free to add and
 *  preview, but exporting a clip that has any requires PRO. */
export function canExportWithTransitions(
  { isPro, transitionCount }: { isPro: boolean; transitionCount: number },
): boolean {
  return transitionCount === 0 || isPro;
}
